import { HTTP } from "../helpers/http-common.js";
import authHeader from "../helpers/auth-header";
import helpers from "../helpers/helpers";

const paymentsService = {
  getPayments,
  storePayment,
  getPaymentDetail,
  deletePayment,
  getBanks,
  getPaymentForms,
  storePaymentForm,
  updatePaymentForm,
  getPaymentForm,
  deletePaymentForm
};

export default paymentsService;

function getPayments(page = 1, search) {
  let params = "";
  if (search.term) {
    params += `&search=${search.term}`;
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.perPage) {
    params += `&perPage=${search.perPage}`;
  }

  return HTTP.get(`payments?page=${page}${params}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function getPaymentDetail(id) {
  return HTTP.get(`payment/${id}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function storePayment(payment = {}) {
  return HTTP({
    method: "post",
    url: "store-payment",
    data: payment,
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function deletePayment(id) {
  return HTTP({
    method: "post",
    url: "delete-payment",
    data: { id: id },
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function getBanks() {
  return HTTP.get(`banks`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function getPaymentForms(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`payment-forms-list?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getPaymentForm(id) {
  return HTTP.get(`payment-form/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storePaymentForm(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-payment-form',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updatePaymentForm(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-payment-form',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deletePaymentForm(id) {
  return HTTP({
    method: 'post',
    url: 'delete-payment-form',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}